import Seo from "@/components/Seo";
import { Hero } from "@/components/Hero";
import { CredibilityBar } from "@/components/home/CredibilityBar";
import { Marquee } from "@/components/Marquee";
import { ServicesSummary } from "@/components/home/ServicesSummary";
import { Results } from "@/components/home/Results";
import { Manifesto } from "@/components/Manifesto";
import { HowWeWork } from "@/components/home/HowWeWork";
import { SoftwareSpotlight } from "@/components/home/SoftwareSpotlight";
import { CtaSection } from "@/components/CtaSection";

export default function Home() {
  return (
    <>
      <Seo
        title="Covelli — Marketing Agency for Brands Ready to Scale"
        siteName="Covelli"
        description="Covelli is a marketing agency built for brands that refuse to blend in. Growth strategy, paid ads, creative and marketing systems from Toronto."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Covelli",
          email: "team@covelli.ca",
          description:
            "Marketing agency helping companies scale through growth strategy, paid ads, creative and marketing systems.",
        }}
      />
      <Hero />
      <CredibilityBar />
      <Marquee />
      <ServicesSummary />
      <Results />
      <Manifesto />
      <HowWeWork />
      <SoftwareSpotlight />
      <CtaSection
        testid="home-final-cta"
        headline="Ready to stop guessing and start scaling?"
        subtext="No pressure. Just a clear plan and honest answers."
        buttonText="Book Your Strategy Call"
      />
    </>
  );
}
